import styled from 'styled-components';

export const LangChooserWrapperStyled = styled.div`
    display: inline-block;
    .arrow-icon {
        transform: rotate(0);
        transition: transform 200ms ease;
    }
    .show {
        .arrow-icon {
            transform: rotate(180deg);
        }
    }
    .dropdown-menu {
        width: 100%;
    }
`;
